import { defaultExploreConfig, parseExploreQuery, serializeExploreQuery, type ExploreConfig } from "@/demos/explore/config";
import type { DemoAction, DemoControlState } from "@/demos/types";

export function initialDemoControls(search = window.location.search): DemoControlState {
  const explore = parseExploreQuery(search);
  return {
    seeFocus: "none",
    exploreVariant: explore.variant,
    exploreInspection: explore.inspection,
    exploreAnimation: explore.animation,
    exploreHotspot: "none",
    engageSide: "front",
    engageContent: "reference",
    engagePlaying: false,
    engageMediaError: false,
  };
}

export function demoControlReducer(state: DemoControlState, action: DemoAction): DemoControlState {
  switch (action.type) {
    case "see-focus": return { ...state, seeFocus: action.value };
    case "explore-variant": return { ...state, exploreVariant: action.value };
    case "explore-inspection": return { ...state, exploreInspection: action.value };
    case "explore-animation": return { ...state, exploreAnimation: action.value };
    case "explore-hotspot": return { ...state, exploreHotspot: action.value };
    case "explore-reset": return {
      ...state,
      exploreVariant: defaultExploreConfig.variant,
      exploreInspection: defaultExploreConfig.inspection,
      exploreAnimation: defaultExploreConfig.animation,
      exploreHotspot: "none",
    };
    case "engage-side": return { ...state, engageSide: action.value };
    case "engage-content": return { ...state, engageContent: action.value };
    case "engage-playing": return { ...state, engagePlaying: action.value };
    case "engage-media-error": return { ...state, engageMediaError: action.value };
  }
}

export function writeExploreControlsToUrl(config: ExploreConfig): void {
  const url = new URL(window.location.href);
  for (const key of ["cover", "finish", "motion", "configVersion", "variant", "inspection", "animation"]) {
    url.searchParams.delete(key);
  }
  const configParams = new URLSearchParams(serializeExploreQuery(config));
  configParams.delete("demo");
  configParams.forEach((value, key) => url.searchParams.set(key, value));
  window.history.replaceState(null, "", url);
}
